import { useState } from "react";
import { toast } from "sonner";
import { Volume2, VolumeX, Check } from "lucide-react";
import { SOUNDS, getSound, setSound, playChime } from "@/lib/push";

export const SoundSettings = () => {
  const [cur, setCur] = useState(getSound());
  const pick = (id) => {
    setSound(id);
    setCur(id);
    playChime(id);
    toast.success(id === "off" ? "Bunyi notifikasi dimatikan" : `Nada notifikasi: ${SOUNDS.find((s) => s.id === id).label}`);
  };
  return (
    <div className="bg-white border border-slate-200 rounded-2xl p-4" data-testid="sound-settings">
      <div className="flex items-center gap-3 mb-3">
        <span className="h-9 w-9 rounded-xl bg-gradient-to-br from-sky-500 to-blue-700 text-white flex items-center justify-center">
          {cur === "off" ? <VolumeX className="h-4 w-4" /> : <Volume2 className="h-4 w-4" />}
        </span>
        <div>
          <div className="font-semibold text-slate-800">Nada Notifikasi</div>
          <div className="text-[11px] text-slate-500">Berlaku saat aplikasi dibuka. Saat ditutup, bunyi mengikuti pengaturan HP.</div>
        </div>
      </div>
      <div className="grid grid-cols-2 gap-2">
        {SOUNDS.map((s) => (
          <button key={s.id} onClick={() => pick(s.id)} data-testid={`sound-option-${s.id}`} aria-pressed={cur === s.id}
            className={`flex items-center justify-between gap-2 px-3 py-2.5 rounded-xl border text-sm font-semibold transition-colors ${cur === s.id ? "border-blue-600 bg-blue-50 text-blue-800" : "border-slate-200 text-slate-700 hover:bg-slate-50"}`}>
            <span className="flex items-center gap-2">{s.id === "off" ? <VolumeX className="h-4 w-4" /> : <Volume2 className="h-4 w-4" />}{s.label}</span>
            {cur === s.id && <Check className="h-4 w-4" />}
          </button>
        ))}
      </div>
    </div>
  );
};
